// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"8d9bb8f3","707":"7fbe8fe4","934":"b860eec9"}[chunkId] + ".chunk.js";
};